import React from 'react'
import { Badge } from 'antd'
import styled from 'styled-components'
import { AssistantBuddy } from './AssistantBuddy'
import { FLORIA_TOKENS } from '../styles/tokens'

export type AssistantLauncherProps = {
  urgentCount: number
  onOpen: () => void
}

// Sage hover/focus overlays — FLORIA_TOKENS.accent.primary (#3f6b51) as
// rgba alpha tints sitting over any underlying surface.
const LauncherButton = styled.button`
  width: 72px;
  height: 72px;
  border-radius: 50%;
  /* transparent border at rest keeps the box model stable on hover */
  border: 1px solid transparent;
  padding: 0;
  background: transparent;
  box-shadow: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${FLORIA_TOKENS.accent.primary};
  transition: background 0.2s ease, border-color 0.2s ease, transform 0.2s ease;

  &:hover,
  &:focus-visible {
    background: rgba(${FLORIA_TOKENS.accentRgb.primary}, 0.08);
    border-color: rgba(${FLORIA_TOKENS.accentRgb.primary}, 0.35);
    transform: translateY(-1px);
  }

  &:focus-visible {
    outline: 2px solid rgba(${FLORIA_TOKENS.accentRgb.primary}, 0.45);
    outline-offset: 2px;
  }
`

export const AssistantLauncher: React.FC<AssistantLauncherProps> = ({
  urgentCount,
  onOpen,
}) => {
  return (
    <div
      data-cy="assistant--launcher"
      style={{
        position: 'fixed',
        top: 8,
        right: 8,
        zIndex: 150,
      }}
    >
      <Badge
        count={urgentCount}
        overflowCount={99}
        offset={[-8, 8]}
        showZero={false}
        data-cy="assistant--launcher_urgent-badge"
      >
        <LauncherButton
          type="button"
          onClick={onOpen}
          data-cy="action--assistant_open"
          aria-label="Ouvrir Floria"
        >
          {/* Collapsed launcher is mounted globally on every route. A looping
              Lottie here drives a perpetual rAF loop app-wide — freeze it on
              the first frame (matches AssistantBuddy's documented intent for
              small icons). The animated buddy lives in the expanded panel. */}
          <AssistantBuddy size={60} title="" staticFrame />
        </LauncherButton>
      </Badge>
    </div>
  )
}
